import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

const selectSettings = (state: RootState) => state.video.settings;

export const selectPlayerConfig = createSelector([selectSettings], (s) => ({
  ...s.controls,
  ...s.player,

  ctaBtn: s.cta.addCtaBtn
    ? {
        ...s.cta,
      }
    : null,

  form: s.form.customTime
    ? {
        time: s.form.time,
      }
    : null,

  playback: s.playback.addPlayback
    ? {
        ...s.playback,
      }
    : null,
  preview: s.preview.addPreview
    ? {
        ...s.preview,
      }
    : null,
}));
